import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PrivacyTerms = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button 
        startIcon={<ArrowBackIcon />} 
        onClick={() => navigate(-1)}
        sx={{ mb: 3 }}
      >
        Indietro
      </Button>

      <Paper elevation={0} sx={{ p: 4, backgroundColor: '#f5f5f7' }}>
        {/* TERMINI DI SERVIZIO */}
        <Box sx={{ mb: 6 }}>
          <Typography variant="h4" sx={{ mb: 3, color: '#417a2a', fontWeight: 'bold' }}>
            Termini di Servizio
          </Typography>
          
          <Typography variant="body1" paragraph>
            Benvenuto nella piattaforma Rete Alumni della Fondazione Minoprio. Questi termini di servizio regolano l'accesso e l'utilizzo della nostra piattaforma. Leggendoli attentamente e accettandoli, accetti di essere vincolato da questi termini.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            1. Uso della Piattaforma
          </Typography>
          <Typography variant="body1" paragraph>
            La piattaforma è fornita per permettere agli utenti (alumni e aziende partner) di connettersi, condividere opportunità lavorative e sviluppare relazioni professionali. L'utente accetta di utilizzare la piattaforma esclusivamente per scopi legittimi e in conformità alle leggi applicabili.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            2. Responsabilità dell'Utente
          </Typography>
          <Typography variant="body1" paragraph>
            L'utente è responsabile di mantenere la riservatezza delle proprie credenziali di accesso e di tutte le attività che si verificano sotto il suo account. L'utente accetta di notificare immediatamente Fondazione Minoprio di qualsiasi accesso non autorizzato al suo account.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            3. Contenuti e Comportamento
          </Typography>
          <Typography variant="body1" paragraph>
            L'utente non deve pubblicare, inviare o condividere contenuti che siano offensivi, discriminatori, illegali o che violino i diritti di terzi. Fondazione Minoprio si riserva il diritto di rimuovere qualsiasi contenuto violativo e di sospendere o terminare l'account dell'utente.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            4. Esclusione di Garanzie
          </Typography>
          <Typography variant="body1" paragraph>
            La piattaforma è fornita "così com'è" senza garanzie di alcun tipo. Fondazione Minoprio non garantisce che la piattaforma sia priva di errori o interruzioni. In nessun caso Fondazione Minoprio sarà responsabile per danni diretti, indiretti, incidentali o consequenziali derivanti dall'uso della piattaforma.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            5. Modifiche ai Termini
          </Typography>
          <Typography variant="body1" paragraph>
            Fondazione Minoprio si riserva il diritto di modificare questi termini in qualsiasi momento. L'utilizzo continuato della piattaforma dopo le modifiche costituisce accettazione dei nuovi termini.
          </Typography>
        </Box>

        <Box sx={{ borderTop: '2px solid #417a2a', pt: 6, mb: 6 }}>
          {/* PRIVACY POLICY */}
          <Typography variant="h4" sx={{ mb: 3, color: '#417a2a', fontWeight: 'bold' }}>
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph>
            La presente Privacy Policy descrive come Fondazione Minoprio raccoglie, utilizza e protegge i dati personali degli utenti della piattaforma Rete Alumni.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            1. Dati Raccolti
          </Typography>
          <Typography variant="body1" paragraph>
            Raccogliamo i seguenti dati personali durante la registrazione e l'utilizzo della piattaforma:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1" paragraph>Dati di identificazione: nome, cognome, email, numero di telefono</Typography>
            <Typography component="li" variant="body1" paragraph>Dati anagrafici: data di nascita, luogo di nascita, indirizzo</Typography>
            <Typography component="li" variant="body1" paragraph>Dati professionali: competenze, formazione, CV, link LinkedIn</Typography>
            <Typography component="li" variant="body1" paragraph>Dati di utilizzo: accessi, interazioni sulla piattaforma, annunci visualizzati</Typography>
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            2. Utilizzo dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            I dati personali vengono utilizzati per:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1" paragraph>Gestire e autenticare gli account utente</Typography>
            <Typography component="li" variant="body1" paragraph>Facilitare le connessioni tra alumni e aziende partner</Typography>
            <Typography component="li" variant="body1" paragraph>Inviare notifiche relative a opportunità lavorative</Typography>
            <Typography component="li" variant="body1" paragraph>Migliorare e personalizzare l'esperienza sulla piattaforma</Typography>
            <Typography component="li" variant="body1" paragraph>Comunicazioni amministrative e di supporto</Typography>
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            3. Protezione dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            Fondazione Minoprio implementa misure di sicurezza appropriate per proteggere i dati personali da accesso non autorizzato, alterazione, divulgazione o distruzione. Tuttavia, nessun sistema di sicurezza è impenetrabile.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            4. Condivisione dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            I dati personali non vengono condivisi con terzi senza il consenso dell'utente, eccetto quando richiesto dalla legge. Aziende partner sulla piattaforma potranno visualizzare i profili pubblici degli alumni.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            5. Diritti dell'Utente
          </Typography>
          <Typography variant="body1" paragraph>
            L'utente ha il diritto di accedere, correggere o eliminare i propri dati personali. Per esercitare questi diritti, contattare l'amministratore della piattaforma.
          </Typography>

          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
            6. Contatti
          </Typography>
          <Typography variant="body1" paragraph>
            Per domande sulla presente Privacy Policy o sui termini di servizio, contattare: <strong>privacy@fondazioneminoprio.it</strong>
          </Typography>
        </Box>

        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 4 }}>
          Ultimo aggiornamento: 19 Gennaio 2026
        </Typography>
      </Paper>
    </Container>
  );
};

export default PrivacyTerms;
